export default "__VITE_ASSET__1EfRP$7q__"